import Vue from 'vue';
import { getField, updateField } from 'vuex-map-fields';
import remove from 'lodash/remove';
import SubmissionError from '../../error/SubmissionError';
import CredentialError from '../../error/CredentialError';

const handleError = (commit, e) => {

  commit(ACTIONS.TOGGLE_LOADING,false);
  if (e instanceof CredentialError) {
    if (!e.errors.connected) {
      commit(ACTIONS.SET_CREDENTIAL, 'NotConnected');
      return;
    }
  }

  if (e instanceof SubmissionError) {
    commit(ACTIONS.SET_VIOLATIONS, e.errors);
    // eslint-disable-next-line
    commit(ACTIONS.SET_ERROR, e.errors._error);

    return;
  }

  // eslint-disable-next-line
  commit(ACTIONS.SET_ERROR, e.message);
};

const ACTIONS = {
  ADD: 'ADD',
  ADD_DATA: 'ADD_DATA',
  MERCURE_DELETED: 'MERCURE_DELETED',
  MERCURE_MESSAGE: 'MERCURE_MESSAGE',
  MERCURE_OPEN: 'MERCURE_OPEN',
  RESET_LIST: 'RESET_LIST',
  SET_CREATED: 'SET_CREATED',
  SET_UPDATEDATA: 'SET_UPDATEDATA',
  SET_ACTION: 'SET_ACTION',
  SET_ACTIONED: 'SET_ACTIONED',
  SET_UPLOADED: 'SET_UPLOADED',
  SET_DELETED: 'SET_DELETED',
  SET_ERROR: 'SET_ERROR',
  SET_SELECT_ITEMS: 'SET_SELECT_ITEMS',
  SET_TOTAL_ITEMS: 'SET_TOTAL_ITEMS',
  SET_UPDATED: 'SET_UPDATED',
  SET_VIEW: 'SET_VIEW',
  SET_VIOLATIONS: 'SET_VIOLATIONS',
  SET_CREDENTIAL: 'SET_CREDENTIAL',
  TOGGLE_LOADING: 'TOGGLE_LOADING',
  TOGGLE_DOWNLOADING: 'TOGGLE_DOWNLOADING',
};

export default function makeCrudModule({
  normalizeRelations = x => x,
  resolveRelations = x => x,
  service
} = {}) {
  return {
    actions: {
      create: ({ commit }, values) => {
        commit(ACTIONS.SET_ERROR, '');
        commit(ACTIONS.TOGGLE_LOADING,true);

        service
          .create(values)
          .then(response => response.json())
          .then(data => {
            commit(ACTIONS.TOGGLE_LOADING,false);
            commit(ACTIONS.ADD, data);
            commit(ACTIONS.SET_CREATED, data);
          })
          .catch(e => handleError(commit, e));
      },
      del: ({ commit }, item) => {
        commit(ACTIONS.SET_ERROR, '');
        commit(ACTIONS.TOGGLE_LOADING,true);

        service
          .del(item)
          .then(response => response.json())
          .then(() => {
            commit(ACTIONS.TOGGLE_LOADING,false);
            commit(ACTIONS.SET_DELETED, item);
          })
          .catch(e => handleError(commit, e));
      },
      fetchAll: ({ commit, state }, params) => {
        if (!service) throw new Error('No service specified!');
        commit(ACTIONS.SET_ERROR, '');
        commit(ACTIONS.TOGGLE_LOADING,true);
        service
          .findAll({ params })
          .then(response => response.json())
          .then(retrieved => {
            commit(
              ACTIONS.SET_TOTAL_ITEMS,
              retrieved['hydra:totalItems']
            );
            commit(ACTIONS.SET_VIEW, retrieved['hydra:view']);
            //console.log(state.resetList);
            if (true === state.resetList) {
            commit(ACTIONS.RESET_LIST);
            } else {
              //on recharge à chaque fois ( probleme rafraichissement data-table changement de page rapide)
              commit(ACTIONS.RESET_LIST);
            }

            retrieved['hydra:member'].forEach(item => {
              commit(ACTIONS.ADD, normalizeRelations(item));
            });
            commit(ACTIONS.TOGGLE_LOADING,false);
          })
          .catch(e => handleError(commit, e));
      },
      fetchAllData: ({ commit }, parameters) => {
        if (!service) throw new Error('No service specified!');
        let params = parameters['params'];
        commit(ACTIONS.SET_ERROR, '');
        commit(ACTIONS.SET_UPDATEDATA, '');
        service
          .findAll({ params  })
          .then(response => response.json())
          .then(retrieved => {

            if (parameters['data']) {
              let datas = [];
              retrieved['hydra:member'].forEach(item => {
              //  commit(ACTIONS.ADD, normalizeRelations(item));
                datas.push(normalizeRelations(item));
              });
              commit(ACTIONS.ADD_DATA, { 'data' : datas, 'id' : parameters['data'] } );
              commit(ACTIONS.SET_UPDATEDATA, parameters['data']);
            }

          })
          .catch(e => handleError(commit, e));
      },
      fetchSelectItems: (
        { commit }
        , parameters = {}
      ) => {

        let params  = { properties: ['@id', 'name'] };
        commit(ACTIONS.SET_ERROR, '');
        commit(ACTIONS.TOGGLE_LOADING,true);
        params['pagination'] = false;
        if (parameters['orderCol']) {
          params[parameters['orderCol']] = parameters['order'];
        } else {
          params['order[name]'] = 'asc';
        }
        if (parameters['query']) {
          for (var i = 0; i < parameters['query'].length; i++) {

            params[parameters['query'][i]['id']] = parameters['query'][i]['value'];
          }
        }

        if (!service) throw new Error('No service specified!');

        service
          .findAll({ params })
          .then(response => response.json())
          .then(retrieved => {
            commit(
              ACTIONS.SET_SELECT_ITEMS,
              retrieved['hydra:member']
            );
          })
          .catch(e => handleError(commit, e));
      },
      load: ({ commit }, id) => {
        if (!service) throw new Error('No service specified!');

        commit(ACTIONS.TOGGLE_LOADING);
        service
          .find(id)
          .then(response => response.json())
          .then(item => {
            commit(ACTIONS.TOGGLE_LOADING,false);
            commit(ACTIONS.ADD, normalizeRelations(item));
          })
          .catch(e => handleError(commit, e));
      },
      update: ({ commit }, item) => {
        commit(ACTIONS.SET_ERROR, '');
        commit(ACTIONS.TOGGLE_LOADING,true);

        service
          .update(item)
          .then(response => response.json())
          .then(data => {
            commit(ACTIONS.TOGGLE_LOADING,false);
            commit(ACTIONS.SET_UPDATED, data);
          })
          .catch(e => handleError(commit, e));
      },
      data: ({ commit }, parameters) => {
        commit(ACTIONS.SET_ERROR, '');
        commit(ACTIONS.SET_UPDATEDATA, '');
      //  commit(ACTIONS.TOGGLE_LOADING);
        service
          .data(parameters['data'])
          .then(response => response.json())
          .then(item => {
      //      commit(ACTIONS.TOGGLE_LOADING);
            commit(ACTIONS.ADD_DATA, { 'data' : normalizeRelations(item), 'id' : parameters['data'] } );
            commit(ACTIONS.SET_UPDATEDATA, parameters['data']);

          })
          .catch(e => handleError(commit, e));
      },
      datas: ({ commit }, parameters) => {
        if (!service) throw new Error('No service specified!');
        let params = parameters['params'];
        let data = parameters['data'];
        commit(ACTIONS.SET_ERROR, '');
        commit(ACTIONS.SET_UPDATEDATA, '');
        service
          .findAllData({ params  }, data)
          .then(response => response.json())
          .then(retrieved => {

            if (parameters['data']) {
              let datas = [];
              retrieved['hydra:member'].forEach(item => {
              //  commit(ACTIONS.ADD, normalizeRelations(item));
                datas.push(normalizeRelations(item));
              });
              commit(ACTIONS.ADD_DATA, { 'data' : datas, 'id' : parameters['data'] } );
              commit(ACTIONS.SET_UPDATEDATA, parameters['data']);
            }

          })
          .catch(e => handleError(commit, e));
      },
      subItem: ({ commit }, parameters) => {
        commit(ACTIONS.SET_ERROR, '');
        commit(ACTIONS.SET_UPDATEDATA, '');
      //  commit(ACTIONS.TOGGLE_LOADING);
        service
          .findSub(parameters['id'],parameters['data'])
          .then(response => response.json())
          .then(item => {
      //      commit(ACTIONS.TOGGLE_LOADING);

            commit(ACTIONS.ADD_DATA, { 'data' : normalizeRelations(item), 'id' : parameters['id']+ '/'+ parameters['data']} );
            commit(ACTIONS.SET_UPDATEDATA, parameters['id']+ '/'+ parameters['data']);

          })
          .catch(e => handleError(commit, e));
      },
      action: ({ commit },parameters) => {
        commit(ACTIONS.SET_ERROR, '');
        commit(ACTIONS.TOGGLE_LOADING,true);
        commit(ACTIONS.SET_ACTION, parameters['action']);
        service
          .action(parameters['action'],parameters['values'])
          .then(response => response.json())
          .then(data => {
            commit(ACTIONS.TOGGLE_LOADING,false);
            commit(ACTIONS.SET_ACTIONED, data);
          })
          .catch(e => handleError(commit, e));
      },
      actionDownload: ({ commit },parameters) => {
        commit(ACTIONS.SET_ERROR, '');
        commit(ACTIONS.TOGGLE_LOADING,true);
        commit(ACTIONS.SET_ACTION, parameters['action']);
        service
          .action(parameters['action'],parameters['values'])
          .then( response => response.blob())
          .then(blob => {
            commit(ACTIONS.TOGGLE_LOADING,false);
           // commit(ACTIONS.SET_ACTIONED, data);
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob);
            link.download = parameters['name'];
            link.click();
            URL.revokeObjectURL(link.href);
          })
          .catch(e => handleError(commit, e));
      },
      actionPrint: ({ commit }, parameters) => {
        commit(ACTIONS.SET_ERROR, '');
        commit(ACTIONS.TOGGLE_LOADING, true);
        commit(ACTIONS.SET_ACTION, parameters['action']);

        service
          .action(parameters['action'], parameters['values'])
          .then(response => response.blob())
          .then(blob => {
            commit(ACTIONS.TOGGLE_LOADING, false);

            // Création de l'URL temporaire de l'image
            const imageUrl = URL.createObjectURL(blob);

            // Ouvrir une nouvelle fenêtre pour l'impression
            const printWindow = window.open('', '_blank');
            printWindow.document.write(`
              <html>
                <head>
                  <title>${parameters['name']}</title>
                  <style>
                    @page {
                      size: 101mm 54mm;
                      margin: 0;
                    }
                    html, body {
                      margin: 0;
                      padding: 0;
                    }
                    img {
                      width: 101mm;
                      height: 54mm;
                      display: block;
                    }
                  </style>
                </head>
                <body>
                  <img src="${imageUrl}" 
                      onload="window.print(); window.onafterprint = window.close();" />
                </body>
              </html>
            `);
            printWindow.document.close();
          })
          .catch(e => handleError(commit, e));
      },

      upload: ({ commit }, values) => {
        commit(ACTIONS.SET_ERROR, '');
        commit(ACTIONS.TOGGLE_LOADING,true);
        service
          .upload(values)
          .then(response => response.json())
          .then(data => {
            commit(ACTIONS.TOGGLE_LOADING,false);
            commit(ACTIONS.SET_UPLOADED, data);
          })
          .catch(e => handleError(commit, e));
      },
      download: ({ commit }, values) => {
        if (!service) throw new Error('No service specified!');

        commit(ACTIONS.TOGGLE_LOADING,true);
        service
          .download(values)
          .then(response => response.blob()
        )
          .then(blob => {
            commit(ACTIONS.TOGGLE_LOADING,false);
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob);
            link.download = values.name;
            link.click();
            URL.revokeObjectURL(link.href);
          })
          .catch(e => handleError(commit, e));
      },
      downloadBlob: ({ commit }, values) => {
        if (!service) throw new Error('No service specified!');

        commit(ACTIONS.TOGGLE_LOADING,true);
        commit(ACTIONS.TOGGLE_DOWNLOADING, { 'reference' : values['name'], 'isloading' : true } );
        service
          .download(values)
          .then(response => response.blob()
        )
          .then(blob => {
            commit(ACTIONS.TOGGLE_LOADING,false);
            commit(ACTIONS.ADD_DATA, { 'data' : URL.createObjectURL(blob), 'id' : values['name'] } );
            commit(ACTIONS.SET_UPDATEDATA, { 'data' : URL.createObjectURL(blob), 'id' : values['name'] });
            commit(ACTIONS.TOGGLE_DOWNLOADING, { 'reference' : values['name'], 'isloading' : false } );
          })
          .catch(e => handleError(commit, e));
      },
      downloadImage: ({ commit }, values) => {
        if (!service) throw new Error('No service specified!');

        commit(ACTIONS.TOGGLE_LOADING,true);
        commit(ACTIONS.TOGGLE_DOWNLOADING, { 'reference' : values.reference, 'isloading' : true } );
        service
          .download(values)
          .then(response => response.blob()
        )
          .then(blob => {
            commit(ACTIONS.TOGGLE_LOADING,false);
            commit(ACTIONS.ADD_DATA, { 'data' : URL.createObjectURL(blob), 'id' : values.reference } );
            commit(ACTIONS.SET_UPDATEDATA, { 'data' : URL.createObjectURL(blob), 'id' : values.reference });
            commit(ACTIONS.TOGGLE_DOWNLOADING, { 'reference' : values.reference, 'isloading' : false } );

          })
          .catch(e => handleError(commit, e));
      },
      deleteImage: ({ commit }, values) => {

        commit(ACTIONS.SET_ERROR, '');
        commit(ACTIONS.TOGGLE_LOADING,true);
        service
          .deleteImage(values)
          .then(response => response.json())
          .then(data => {
            commit(ACTIONS.TOGGLE_LOADING,false);
            commit(ACTIONS.ADD_DATA, { 'data' : null, 'id' : values.reference } );
            commit(ACTIONS.SET_UPDATEDATA, null);
            commit(ACTIONS.SET_ACTIONED, data);
          })
          .catch(e => handleError(commit, e));
      },
    },
    getters: {
      find: state => id => {
        return resolveRelations(state.byId[id]);
      },
      getField,
      list: (state, getters) => {
        return state.allIds.map(id => getters.find(id));
      },
      data: state => id => {
          return state.alldata[id];
      },
      downloadingImageReference: state => id => {
          return state.allDownloadingImageReference[id];
      }
    },
    mutations: {
      updateField,
      [ACTIONS.ADD]: (state, item) => {
        Vue.set(state.byId, item['@id'], item);
        if (state.allIds.includes(item['@id'])) return;
        state.allIds.push(item['@id']);
      },
      [ACTIONS.ADD_DATA]: (state, alldata) => {
        state.alldata[alldata.id] = alldata.data;
      },
      [ACTIONS.SET_UPDATEDATA]: (state, updatedata) => {
        Object.assign(state, { updatedata , isLoading: false});
      },
      [ACTIONS.RESET_LIST]: state => {
        Object.assign(state, {
          allIds: [],
          byId: {},
          resetList: false
        });
      },
      [ACTIONS.SET_CREATED]: (state, created) => {
        Object.assign(state, { created });
      },
      [ACTIONS.SET_ACTION]: (state, action) => {
        Object.assign(state, { action  });
      },
      [ACTIONS.SET_ACTIONED]: (state, actioned) => {
        Object.assign(state, { actioned , isLoading: false });
      },
      [ACTIONS.SET_UPLOADED]: (state, uploaded) => {
        Object.assign(state, { uploaded });
      },
      [ACTIONS.SET_DELETED]: (state, deleted) => {
        if (!state.allIds.includes(deleted['@id'])) return;
        Object.assign(state, {
          allIds: remove(state.allIds, item => item['@id'] === deleted['@id']),
          byId: remove(state.byId, id => id === deleted['@id']),
          deleted
        });
      },
      [ACTIONS.SET_ERROR]: (state, error) => {
        Object.assign(state, { error, isLoading: false });
      },
      [ACTIONS.SET_SELECT_ITEMS]: (state, selectItems) => {
        Object.assign(state, {
          error: '',
          isLoading: false,
          selectItems
        });
      },
      [ACTIONS.SET_TOTAL_ITEMS]: (state, totalItems) => {
        Object.assign(state, { totalItems });
      },
      [ACTIONS.SET_UPDATED]: (state, updated) => {
        state.byId[updated['@id']] =updated;
        Object.assign(state, {
          updated: updated
        });
      },
      [ACTIONS.SET_VIEW]: (state, view) => {
        Object.assign(state, { view });
      },
      [ACTIONS.SET_VIOLATIONS]: (state, violations) => {
        Object.assign(state, { violations });
      },
      [ACTIONS.TOGGLE_LOADING]: (state, value) => {
        Object.assign(state, { error: '', isLoading: value });
      },
      [ACTIONS.TOGGLE_DOWNLOADING]: (state, value) => {
        state.allDownloadingImageReference[value.reference] = value.isloading;
      },
      [ACTIONS.SET_CREDENTIAL]: (state, error) => {
        Object.assign(state, { error, isLoading: false });
      },
    },
    namespaced: true,
    state: {
      allIds: [],
      alldata: {},
      byId: {},
      created: null,
      uploaded: null,
      updatedata: null,
      action: null,
      actioned: null,
      deleted: null,
      error: '',
      isLoading: false,
      allDownloadingImageReference: {},
      resetList: false,
      selectItems: null,
      totalItems: 0,
      updated: null,
      view: null,
      credential: null,
      violations: null

    }
  };
}
